// extracted by mini-css-extract-plugin
export default {"ctaContainer":"Community_ctaContainer__K59cP","textContent":"Community_textContent__1FM65","ctaButton":"Community_ctaButton__zQ6va"};